export default "__VITE_ASSET__lxrBtinb__"